import React, { useState, useEffect } from 'react' 
import { useNavigate, useLocation, Link } from 'react-router-dom';

import axios from "axios";
import swal from "sweetalert";

export default function EmailEdit() {
  const {state:{id}} = useLocation();
  const nav = useNavigate();
  const [faqData, setFaqData] = useState({});
  const [lang, setLang] = useState('en');
  const [subjectError , setSubjectError] = useState('');
  const [messageError , setMessageError] = useState('');
  useEffect(()=>{
    console.log(' :Load Data: ', id);
    getFaqContent('en')
  },[]);

  const getFaqContent = (language) => {
    //var language  = 
    axios.get(process.env.REACT_APP_API_KEY + "api/admin/faq-show/"+id+"/"+language, {
        headers: {
            "Content-type": "Application/json",
            "Authorization": localStorage.getItem("token")
      }   
    })
    .then((response) => {
      //Check for Authorized
      if(response.data.code == 403){
        localStorage.clear();
        nav('/admin/login');
      }
      console.log('////', response)
        if(response.data.status == true) {
            var responseData = response.data.data;
            setFaqData({
                question:responseData.question,
                answere:responseData.answere
            })
        }})
        .catch(error => {
            //
        })    
  }

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setFaqData(values => ({...values,[name]:value}))
    
    if (event.target.name == 'lang'){
        console.log('event name ===> ',event.target.name);
        setLang(value)
        console.log('selected lang => ', value)
        getFaqContent(value);
    }
  }

  const updateFaq = () =>{
    
    console.log('selected lang ===> ', lang);
    console.log('post data ===> ', faqData);
    console.log('post URL ===> ', process.env.REACT_APP_API_KEY+"api/admin/faq-update/"+id+"/"+lang);

      axios.post(process.env.REACT_APP_API_KEY+"api/admin/faq-update/"+id+"/"+lang,faqData, 
      {
        headers: {
        "Content-type": "Application/json",
        "Authorization": localStorage.getItem("token")
        }   
      }
      ).then((res)=>{
        //Check for Authorized
        if(res.data.code == 403){
          localStorage.clear();
          nav('/admin/login');
        }

        if (res.data.status == true){
            swal({
                title: "Status",
                text: "Data Updated Successfully!",
                icon: "success",
                button: "Okay",
              });
              nav('/admin/faq-list');
        }else{
          const resdata = res.data.data;
          console.log("key=>>>>", resdata);
          Object.keys(resdata).forEach(function(key) {
            
            if(key == 'qusetion'){
              setSubjectError(resdata[key]);
            }
            if(key == 'answere'){
              setMessageError(resdata[key]);
            }
            console.log('Key : ' + key + ', Value : ' + resdata[key])
            console.log(subjectError)
            console.log(messageError)
          })
        } 
      }).catch(error => {
        console.log("err=>>", error);
        console.log('aya',error.response.data);
      })
  }


  return (
    <div className="wrapper">
        <div className="content-wrapper">
            <form  className="mx-5 col-md-5">
                <h2>Edit FAQ</h2>
                <div className="field form-group">               
                    <label>Language</label>
                    <select defaultValue={lang} className="form-control" name="lang" onChange={handleChange}>
                        <option value="en">English</option>
                        <option value="zh">Chinese</option>
                    </select>
                </div>

                <div className="field form-group">               
                        <label>Question</label>
                        <input type="text" name="question" autoComplete="nope" placeholder="Question" className="form-control" onChange={handleChange} value={faqData.question}/>
                        <div className="text-danger">
                            {subjectError ? subjectError : null}
                        </div>
                </div>

                <div className="field form-group">               
                        <label>Answere</label>
                        <textarea type="text" name="answere" autoComplete="nope" placeholder="Answere" rows="8" className="form-control" onChange={handleChange} value={faqData.answere}></textarea>
                        <div className="text-danger">
                            {messageError ? messageError : null}
                        </div>
                </div>
                
                <div className='btn-allign'>
                <button type="button" onClick={updateFaq} className="btn btn-danger submit-btn">Save</button>
                <Link to="/admin/faq-list"><button className="btn btn-primary submit-btn">Back</button></Link>
                </div>
            </form>
        </div>
    </div>
  )
}